import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const exportToPDF = async (
  element: HTMLElement | null,
  filename: string,
) => {
  if (!element) return;

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      // This is the key: clonedDoc is a virtual copy of your page
      onclone: (clonedDoc) => {
        // Find the hidden sections inside the CLONED document
        const header = clonedDoc.querySelector(
          ".print-only-header",
        ) as HTMLElement;
        const footer = clonedDoc.querySelector(
          ".print-only-footer",
        ) as HTMLElement;
        const exportBtn = clonedDoc.querySelector(".export-btn") as HTMLElement;

        // Force them to be visible only in the capture
        if (header) header.style.display = "block";
        if (footer) footer.style.display = "block";

        // Optionally hide the export button in the PDF so it's not a dead button
        if (exportBtn) exportBtn.style.display = "none";
      },
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const imgProps = pdf.getImageProperties(imgData);
    const renderHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, renderHeight);
    pdf.save(`${filename}.pdf`);
  } catch (error) {
    console.error("PDF Export Error:", error);
  }
};

export const downloadCSV = (
  filename: string,
  headers: string[],
  rows: any[][],
) => {
  const csvContent = [
    headers.join(","),
    ...rows.map((r) => r.map((val) => `"${val}"`).join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `${filename}_${new Date().toISOString().split("T")[0]}.csv`,
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const triggerPrint = () => {
  window.print();
};
